"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
const cheminfo_font_1 = require("cheminfo-font");
const fa_1 = require("react-icons/fa");
const isSpectrum1D_1 = require("../../../data/data1d/Spectrum1D/isSpectrum1D");
const ChartContext_1 = require("../../context/ChartContext");
const Button_1 = __importDefault(require("../../elements/Button"));
const BasicPanelStyle_1 = require("../extra/BasicPanelStyle");
const DefaultPanelHeader_1 = __importDefault(require("../header/DefaultPanelHeader"));
const SpectraAutomaticPickingButton_1 = require("../header/SpectraAutomaticPickingButton");
const AutomaticAssignmentTable_1 = __importDefault(require("./AutomaticAssignmentTable"));
const useAutoAssignments_1 = require("./useAutoAssignments");
function useCheckEnableAutomaticAssignments() {
    const { data } = (0, ChartContext_1.useChartData)();
    return data.some((spectrum) => {
        if ((0, isSpectrum1D_1.isSpectrum1D)(spectrum)) {
            return spectrum?.ranges?.values.length > 0;
        }
        return spectrum?.zones?.values.length > 0;
    });
}
function AutomaticAssignment() {
    const { getAssignments, assignments, restAssignments } = (0, useAutoAssignments_1.useAutoAssignments)();
    const enabled = useCheckEnableAutomaticAssignments();
    return ((0, jsx_runtime_1.jsxs)("div", { css: BasicPanelStyle_1.tablePanelStyle, children: [(0, jsx_runtime_1.jsxs)(DefaultPanelHeader_1.default, { showSettingButton: false, canDelete: false, children: [(0, jsx_runtime_1.jsx)(SpectraAutomaticPickingButton_1.SpectraAutomaticPickingButton, {}), (0, jsx_runtime_1.jsx)(Button_1.default.BarButton, { tooltipOrientation: "horizontal", toolTip: "Automatic assignment", onClick: getAssignments, disabled: !enabled, children: (0, jsx_runtime_1.jsx)(cheminfo_font_1.SvgNmrAssignment2, {}) }), (0, jsx_runtime_1.jsx)(Button_1.default.BarButton, { tooltipOrientation: "horizontal", toolTip: "Reset assignment", onClick: restAssignments, children: (0, jsx_runtime_1.jsx)(fa_1.FaBolt, {}) })] }), (0, jsx_runtime_1.jsx)("div", { className: "inner-container", children: (0, jsx_runtime_1.jsx)(AutomaticAssignmentTable_1.default, { data: assignments }) })] }));
}
exports.default = AutomaticAssignment;
